import { IconButtonProps as MuiIconButtonProps } from "@mui/material";
import { IconButton } from "../../components";
import SwipeVerticalTwoTone from "@mui/icons-material/SwipeVerticalTwoTone";

export const GrabIconButton = (
  props: MuiIconButtonProps & {
    disabled?: boolean;
  }
) => {
  const { disabled, ...rest } = props;

  return (
    <IconButton
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      disabled={disabled}
      color="secondary"
      size="small"
      {...rest}
      sx={{
        cursor: "grab",
        "&:active": {
          cursor: "grabbing",
        },
        "&:hover": {
          cursor: "grab",
        },
      }}
    >
      <SwipeVerticalTwoTone />
    </IconButton>
  );
};
